<script setup lang="ts">
import VPaths from "@/components/path/VPaths.vue"
</script>
<template>
  <v-paths />
</template>
